import { useMutation, useQueryClient } from 'react-query'
import { trackedChangesKeys } from './trackedChangesKeys'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { TrackedChange } from 'types'
import { buildErrorMessage } from 'utils'

interface Props {
  articleKey: string
  layerId: string
  trackedChangeId: string
}

interface ResponseData {
  tracked_change: TrackedChange
}

export const useToggleTrackedChangeReaction = ({ articleKey, layerId, trackedChangeId }: Props) => {
  const queryClient = useQueryClient()

  return useMutation<ResponseData, Error, string>(
    trackedChangesKeys.toggleReaction(trackedChangeId),
    async (reaction) => {
      const response = await sendToApi<ResponseData>(
        `/articles/${articleKey}/layers/${layerId}/changes/${trackedChangeId}/toggle_reaction`,
        {
          method: 'POST',
          body: { reaction },
        },
      )

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(trackedChangesKeys.list(layerId, {}))
      },
    },
  )
}
